<template>
  <!-- START MOBILE CONTROLS -->
  <div class="container-fluid relative">
    <!-- LEFT SIDE -->
    <div class="pull-left full-height visible-sm visible-xs">
      <!-- START ACTION BAR -->
      <div class="header-inner">
        <a href="#" class="btn-link toggle-sidebar visible-sm-inline-block visible-xs-inline-block padding-5" data-toggle="sidebar">
          <span class="icon-set menu-hambuger"></span>
        </a>
      </div>
      <!-- END ACTION BAR -->
    </div>
    <div class="pull-center hidden-md hidden-lg">
      <div class="header-inner">
        <div class="brand inline">
          <!-- <img src="~assets/img/logo.png" alt="logo" data-src="~assets/img/logo.png" data-src-retina="~assets/img/logo_2x.png" width="78" height="22"> -->
          <img src="~assets/img/logo-sofradom.png" alt="logo" data-src="~assets/img/logo-sofradom.png" data-src-retina="~assets/img/logo-sofradom.png" width="140">
        </div>
      </div>
    </div>
    <!-- RIGHT SIDE -->
    <!-- <div class="pull-right full-height visible-sm visible-xs"> -->
      <!-- START ACTION BAR -->
      <!-- <div class="header-inner">
        <a href="#" class="btn-link visible-sm-inline-block visible-xs-inline-block" data-toggle="quickview" data-toggle-element="#quickview">
          <span class="icon-set menu-hambuger-plus"></span>
        </a>
      </div> -->
      <!-- END ACTION BAR -->
    <!-- </div> -->
    
    <user-info :logout="logoutUser" :email="me.email" :mobile="true"></user-info>
  </div>
  <!-- END MOBILE CONTROLS -->
</template>

<script type="text/babel">
import UserInfo from './UserInfo'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    UserInfo
  },

  computed: {
    ...mapState({
      me: state => state.user.me,
    }),
  },

  methods: {
    ...mapActions(['logoutUser'])
  },
}
</script>



// WEBPACK FOOTER //
// client/components/Header/MobileControls.vue